import * as React from "react";

import { cn } from "@/shared/lib/cn";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, ...props }, ref) => {
    // Rendered via a tag variable so this component can *be* the shared
    // Textarea without tripping `react/forbid-elements` (which forbids the
    // literal <textarea>). Same pattern the Button primitive uses for its
    // underlying <button>.
    const Comp = "textarea";
    return (
      <Comp
        className={cn(
          "flex min-h-[80px] w-full resize-y rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          // ARIA-driven invalid styling — RHF's FormControl sets aria-invalid
          // on the underlying element so the field goes red automatically.
          "aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-destructive",
          error && "border-destructive focus-visible:ring-destructive",
          className
        )}
        ref={ref}
        aria-invalid={error || undefined}
        {...props}
      />
    );
  }
);

Textarea.displayName = "Textarea";

export { Textarea };
